import { useEffect, useRef } from "react";
import SignalRConnection from "services/signalRConnection";
import { RealtimeManager } from "../../realtime";
import {
    handleBidPointDatesUpdate,
    handleBookingCommentUpdate,
    handleCarHasPlannedBidUpdate,
    handleCarResourceActivityUpdate,
    handleCarUpdate,
    handleDriverUpdate,
    handleEstimatedLeaveDateUpdate,
    handlePlanningCommentUpdate,
    handleTrailerUpdate,
} from "./handlers";

const Connection = ({ children, data }) => {
    const connection = useRef();

    useEffect(() => {
        RealtimeManager.init({ data });

        return () => {
            RealtimeManager.clear();
        };
    }, [data]);

    useEffect(() => {
        connection.current = new SignalRConnection({
            url: "/signalr/planning",
            actions: [
                { name: "BidPointDatesUpdate", action: handleBidPointDatesUpdate },
                { name: "BookingCommentUpdate", action: handleBookingCommentUpdate },
                { name: "CarUpdate", action: handleCarUpdate },
                { name: "DriverUpdate", action: handleDriverUpdate },
                { name: "EstimatedLeaveDateUpdate", action: handleEstimatedLeaveDateUpdate },
                { name: "CarHasPlannedBidUpdate", action: handleCarHasPlannedBidUpdate },
                { name: "PlanningCommentUpdate", action: handlePlanningCommentUpdate },
                { name: "CarResourceActivityUpdate", action: handleCarResourceActivityUpdate },
                { name: "TrailerUpdate", action: handleTrailerUpdate },
            ],
            joinActionName: "Join",
            leaveActionName: "Leave",
        });

        return () => {
            connection.current?.disconnect();
        };
    }, []);

    return children;
};

export default Connection;
